<script setup lang="ts">
  export interface StatusTab {
    value: string;
    label: string;
    count?: number;
  }

  defineProps<{ tabs: StatusTab[] }>();

  const model = defineModel<string>({ required: true });
</script>

<template>
  <div
    role="tablist"
    class="flex items-center gap-5">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      role="tab"
      :aria-selected="model === tab.value"
      class="relative flex items-center gap-1.5 pb-2.5 text-13 transition-colors after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:rounded-full after:transition-colors"
      :class="
        model === tab.value
          ? 'font-semibold text-primary after:bg-ring'
          : 'text-muted-foreground hover:text-primary after:bg-transparent'
      "
      @click="model = tab.value">
      {{ tab.label }}
      <span
        v-if="tab.count !== undefined"
        class="text-2xs font-normal tabular-nums text-foreground-subtle">
        {{ tab.count }}
      </span>
    </button>
  </div>
</template>
